import i18n from "../../../i18n";
import { AclMemberType } from "../../../services/security/types";

export const channelAccessFields = [
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true
    },
    {
        key: "username",
        label: i18n.t("channels.acl.username"),
        sortable: true
    },
    {
        key: "type",
        label: i18n.t("common.type"),
        formatter: formatType,
        sortable: true
    },
    {
        key: "actions",
        label: ""
    }
];

export const addChannelAccessFields = [
    {
        key: "name",
        label: i18n.t("common.name")
    },
    {
        key: "username",
        label: i18n.t("channels.acl.username")
    },
    {
        key: "type",
        label: i18n.t("common.type"),
        formatter: formatType
    },
    {
        key: "access",
        label: ""
    }
];

// helper methods
function formatType(type: AclMemberType) {
    return AclMemberType[type].toString();
}
